import PropTypes from "prop-types"
import styles from "../HowToWork.module.scss"

export function AlertMessages({ children }) {
    return (
        <div className={styles.alert}>
            <span className={styles.alertIcon} aria-hidden="true">
                !
            </span>
            <div className={styles.alertContent}>{children}</div>
        </div>
    )
}

AlertMessages.propTypes = {
    children: PropTypes.node.isRequired,
}
